import React from 'react';

// Minimalist Square with Rounded Corners
const LogoOption2 = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 200 200"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="logo2Gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#10b981', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#059669', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#047857', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Rounded square background */}
      <rect
        x="20"
        y="20"
        width="160"
        height="160"
        rx="30"
        fill="url(#logo2Gradient)"
      />
      
      {/* Inner accent rectangle */}
      <rect
        x="40"
        y="40"
        width="120"
        height="120"
        rx="20"
        fill="none"
        stroke="white"
        strokeWidth="2"
        opacity="0.2"
      />
      
      {/* TYJ in modern font */}
      <text
        x="100"
        y="120"
        fontFamily="Arial, sans-serif"
        fontSize="60"
        fontWeight="900"
        fill="white"
        textAnchor="middle"
        dominantBaseline="middle"
        letterSpacing="2"
      >
        TYJ
      </text>
      
      {/* Small subtitle */}
      <text
        x="100"
        y="155"
        fontFamily="Arial, sans-serif"
        fontSize="12"
        fontWeight="600"
        fill="white"
        textAnchor="middle"
        opacity="0.9"
        letterSpacing="3"
      >
        GROUP
      </text>
    </svg>
  );
};

export default LogoOption2;